import { render, staticRenderFns } from "./group-detail-income.vue?vue&type=template&id=2ac208d4&"
import script from "./group-detail-income.ts?vue&type=script&lang=js&"
export * from "./group-detail-income.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports